import React from "react";
import { Link } from "react-router-dom";

const CapeGannetImg = "/Images/Capes.jpg";

const CapeGannet = () => {
  return (
    <>
    <section
      className="vh-100 position-relative"
      style={{
        backgroundImage: `url(${CapeGannetImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          background:
            "linear-gradient(rgba(0,0,0,.15), rgba(0,0,0,.45))"
        }}
      />

      <div className="container-fluid h-100 position-relative">
        <div className="row h-100 align-items-center">
          <div className="col-lg-7 col-md-9">

            <div
              className="text-white"
              style={{
                marginLeft: "40px",
                marginTop: "80px"
              }}
            >
              <div className="d-flex align-items-center gap-2 mb-3">

                <small
                  className="fw-semibold"
                  style={{
                    letterSpacing: "1px"
                  }}
                >
                  ← All Species
                </small>

                <span
                  className="badge bg-danger px-3 py-2"
                  style={{
                    fontSize: "9px",
                    letterSpacing: "1px"
                  }}
                >
                  ENDANGERED
                </span>

              </div>

              <h1
                className="fw-normal mb-4"
                style={{
                  fontFamily: "Georgia, serif",
                  fontSize: "5rem",
                  lineHeight: ".95"
                }}
              >
                Cape
                <br />
                Gannet
              </h1>

              <p
                className="fst-italic mb-4"
                style={{
                  fontSize: "18px",
                  color: "rgba(255,255,255,.85)"
                }}
              >
                Morus capensis · Coastal waters ·
                Southern Africa
              </p>

              <hr
                className="border-light opacity-75"
                style={{
                  width: "520px"
                }}
              />

              <div className="d-flex gap-5 mt-4">

                <div>
                  <h2
                    className="fw-normal mb-1"
                    style={{
                      fontFamily: "Georgia, serif",
                      fontSize: "3rem"
                    }}
                  >
                    52%
                  </h2>

                  <small
                    className="text-uppercase"
                    style={{
                      letterSpacing: "1px"
                    }}
                  >
                    DECLINE OVER 3 GENERATIONS
                  </small>
                </div>

                <div>
                  <h2
                    className="fw-normal mb-1"
                    style={{
                      fontFamily: "Georgia, serif",
                      fontSize: "3rem"
                    }}
                  >
                    6
                  </h2>

                  <small
                    className="text-uppercase"
                    style={{
                      letterSpacing: "1px"
                    }}
                  >
                   BREEDING COLONIES WORLDWIDE
                  </small>
                </div>

                <div>
                  <h2
                    className="fw-normal mb-1"
                    style={{
                      fontFamily: "Georgia, serif",
                      fontSize: "3rem"
                    }}
                  >
                    Endangered
                  </h2>

                  <small
                    className="text-uppercase"
                    style={{
                      letterSpacing: "1px"
                    }}
                  >
                   IUCN RED LIST
                  </small>
                </div>

              </div>

            </div>

          </div>
        </div>
      </div>
    </section>

    <section
  className="py-5"
  style={{
    background: "#f5f3ee"
  }}
>
  <div
    className="container"
    style={{
      maxWidth: "1100px"
    }}
  >
    <div className="row g-5">

      {/* LEFT SIDEBAR */}

      <div className="col-lg-3">

        <div
          className="p-4 mb-4"
          style={{
            background: "#ece9e2"
          }}
        >
          <h6
            style={{
              fontFamily: "Georgia, serif"
            }}
          >
            Support This Work
          </h6>

          <p
            className="small text-muted"
          >
            Field research, community programs, and habitat
            protection all depend on donations.
          </p>

          <button
            className="btn w-100 text-white rounded-0"
            style={{
              background: "#6d735d"
            }}
          >
            <Link to="/donate" style={{ textDecoration: "none", color: "white" }}>
              DONATE
            </Link>
          </button>
        </div>

        <small
          className="text-uppercase text-muted"
          style={{
            fontSize: "10px",
            letterSpacing: "2px"
          }}
        >
          Related Articles
        </small>

        <div className="border-top py-3">
          <Link to="/african-penguin" className="text-decoration-none text-dark">
            <div>African Penguin →</div>
          </Link>
          <small className="text-muted">
            Critically Endangered
          </small>
        </div>

        <div className="border-top py-3">
          <Link to="/bearded-vulture" className="text-decoration-none text-dark">
            <div>Bearded Vulture →</div>
          </Link>
          <small className="text-muted">
            Endangered
          </small>
        </div>

        <div className="border-top py-3">
          <Link to="/pels-fishing-owl" className="text-decoration-none text-dark">
            <div>Pel's Fishing Owl →</div>
          </Link>
          <small className="text-muted">
            Vulnerable
          </small>
        </div>

      </div>

      {/* MAIN CONTENT */}

      <div className="col-lg-9">

        <div className="row mb-5">

          <div className="col-lg-7">
            <p
              className="text-secondary"
              style={{
                lineHeight: "2",
                fontSize: "14px"
              }}
            >
              Watch a Cape Gannet hunt and you will never forget it. From heights of
up to 30 meters, it folds its wings and plunges into the ocean like an arrow
at speeds approaching 90 kilometers per hour. Found only along the
southwestern African coast, it is one of the ocean's most spectacular
hunters and one of the most endangered seabirds in the world. All six
of its remaining breeding colonies are at risk.
            </p>
          </div>

          <div className="col-lg-5">

            <div className="row text-center" style={{
          fontFamily:
            "Hind Madurai,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif",
          fontSize: "17px",
          fontWeight: 600,
          marginBottom: "4px",
          lineHeight: 1.3,
        }}>

              <div className="col-4">
                <p>2.6 kg (5.6 lbs.)</p>
                <small  style={{
           fontFamily:
            "Hind Madurai,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif",
          fontSize: "14px",
          color: "#888",
        }}>Average Weight</small>
              </div>

              <div className="col-4">
                <p>84–94 cm (33–37 inches)</p>
                <small  style={{
           fontFamily:
            "Hind Madurai,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif",
          fontSize: "14px",
          color: "#888",
        }}>Average Height</small>
              </div>

              <div className="col-4">
                <p>13–14 years</p>
                <small  style={{
           fontFamily:
            "Hind Madurai,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif",
          fontSize: "14px",
          color: "#888",
        }}>Average Lifespan</small>
              </div>

            </div>

          </div>

        </div>

        {/* PERSONAL NOTE */}

        <div
          className="bg-white p-4 mb-4 border-start border-warning border-3"
        >
          <small
            className="text-uppercase text-warning fw-bold"
          >
            A Personal Note
          </small>

          <p
            className="fst-italic mt-3 mb-0"
            style={{
              fontFamily: "Georgia, serif",
              fontSize: "18px"
            }}
          >
            ""Cape Gannets are one of those species where you see a photo of 50,000 birds on 
an island and you think that's actually a warning sign, not a success story. 
Six colonies. That's all that's left.""
          </p>
        </div>

        {/* STATUS */}

        <div
          className="text-white p-4 mb-5"
          style={{
            background: "#6d735d"
          }}
        >
          <small
            className="text-uppercase"
            style={{
              letterSpacing: "2px"
            }}
          >
            Conservation Status
          </small>

          <p className="mb-0 mt-2">
            The Cape Gannet is listed as Endangered on the IUCN Red List, with a decreasing population trend. The species has declined by approximately 52% over three generations. It is found at only six breeding colonies in the world three in South Africa and three in Namibia all within the Benguela upwelling ecosystem. The Namibian population is considered Critically Endangered at a national level, having suffered catastrophic declines. While South Africa's Bird Island colony in Algoa Bay has grown, overall global numbers remain deeply concerning.
          </p>
        </div>

        {/* TROUBLE */}

        <h2
          className="mb-5"
          style={{
            fontFamily: "Georgia, serif"
          }}
        >
          Why This Species Is In Trouble
        </h2>

        <div className="position-relative mb-5">

          <div
            className="position-absolute"
            style={{
              left: "4px",
              top: 0,
              bottom: 0,
              width: "1px",
              background: "#ddd"
            }}
          />

          {[
            {
              title: "Collapse of Fish Stocks",
              text: "Cape Gannets feed almost exclusively on sardines and anchovies. Industrial fishing has devastated these fish populations along the Benguela Current and the gannets are paying the price. Adults return from longer and longer foraging trips and still comeback empty."
            },
            {
              title: "Fishing Gear Entanglement",
              text: "Gannets plunge-dive at extraordinary speeds into waters shared with commercial fishing fleets Entanglement in trawl nets and longlines kills thousands annually atoll that is almost certainly underreported."
            },
            {
              title: "Six Colonies. All at Risk.",
              text: "The entire global Cape Gannet population breeds at just six island colonies. There is no redundancy. A disease outbreak, a severe oil spill, or a prolonged crash in local fish stocks at any one colony could be catastrophic."
            },
            {
              title: "Invasive Predators",
              text: "On some breeding islands, introduced predators mice, rats, cats take eggs and small chicks during an already difficult breeding season. Even small levels of predation can tip a struggling colony into decline."
            }
          ].map((item, index) => (
            <div
              className="d-flex mb-5"
              key={index}
            >
              <div
                className="rounded-circle me-4 mt-2"
                style={{
                  width: "8px",
                  height: "8px",
                  background: "#c98d2c",
                  zIndex: 2
                }}
              />

              <div>
                <h6
                  style={{
                    fontFamily: "Georgia, serif"
                  }}
                >
                  {item.title}
                </h6>

                <p
                  className="text-muted"
                  style={{
                    fontSize: "13px",
                    lineHeight: "1.8"
                  }}
                >
                  {item.text}
                </p>
              </div>
            </div>
          ))}

        </div>

        {/* QUOTE */}

        <div
          className="text-white p-5 my-5"
          style={{
            background: "#6d735d"
          }}
        >
          <div
            style={{
              fontSize: "40px",
              color: "#e0b04b"
            }}
          >
            "
          </div>

          <p
            className="fst-italic mb-0"
            style={{
              fontFamily: "Georgia, serif",
              fontSize: "24px"
            }}
          >
           When fish disappear from waters near the colony, the entire ecosystem shifts predators turn on gannet chicks, parents abandon nests, and entire breeding seasons are lost.
          </p>
        </div>

        {/* ACTIONS */}

        <h2
          className="mb-4"
          style={{
            fontFamily: "Georgia, serif"
          }}
        >
          We're supporting the following activities
        </h2>

        <div className="d-flex flex-column gap-2 mb-5">

          {[
            "Satellite tracking of gannet foraging movements throughout the year",
            "Fisheries policy advocacy for sustainable catch quotas",
            "Invasive species removal operations on breeding islands",
            "Annual breeding census across all six colony sites",
            "Ocean temperature monitoring and ecosystem modeling"
          ].map((item, index) => (
            <div
              key={index}
              className="bg-white border px-3 py-3"
            >
              <span
                className="me-2"
                style={{
                  color: "#c98d2c"
                }}
              >
                ○
              </span>

              {item}
            </div>
          ))}

        </div>

        {/* IMAGE BLOCK */}

        <div
          className="p-4 text-white"
          style={{
            background: "#6d735d"
          }}
        >
          <small
            className="text-uppercase"
            style={{
              letterSpacing: "2px"
            }}
          >
            Reasons For Hope
          </small>

          <p className="mt-2">
            Seabird island restoration projects are removing invasive predators
with measurable success. Annual breeding censuses provide the
data governments need to justify stronger fishing regulations.
          </p>

          <img
            src="/Images/Capes1.png"
            alt=""
            className="img-fluid w-100"
          />
        </div>

      </div>

    </div>
  </div>
</section>
    
    </>
  );
};

export default CapeGannet;
